import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  link: {
    fontFamily: 'Roboto Condensed',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: ({ light }) =>
      light ? theme.palette.text.white : theme.palette.text.main,
    textDecoration: 'none',
    cursor: 'pointer',
    height: 30,
    margin: theme.spacing(2, 0),
  },

  wrapper: {
    margin: theme.spacing(6, 0),
  },
}))
